/* Separate product navigation; native Dawn still owns variant and cart updates. */
if (!customElements.get('naked-more-designs')) {
  customElements.define('naked-more-designs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.productInfo = this.closest('product-info');
      this.sourceOptions = JSON.parse(this.querySelector('[data-source-options]').textContent);
      this.deviceOption = this.findDevice(this.sourceOptions);
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-design-link]');
        if (link && !link.hasAttribute('aria-current')) this.updateLink(link);
      }, { signal });
      this.addEventListener('focusin', event => {
        const link = event.target.closest('[data-design-link]');
        if (link && !link.hasAttribute('aria-current')) this.updateLink(link);
      }, { signal });
      this.productInfo.addEventListener('change', event => {
        if (!event.target.closest('variant-selects')) return;
        if (this.requiresDevice && this.selectedDevice()) {
          this.requiresDevice = false;
          this.querySelector('[role="status"]').hidden = true;
        }
        this.querySelectorAll('[data-design-link]:not([aria-current])').forEach(link => this.updateLink(link));
      }, { signal });
      this.productInfo.addEventListener('submit', event => {
        if (!this.requiresDevice) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.productInfo.querySelector('variant-selects input, variant-selects select')?.focus();
      }, { signal, capture: true });
      if (new URL(window.location.href).searchParams.has('naked_choose_device') && this.deviceOption) this.requireDevice();
    }

    disconnectedCallback() { this.controller?.abort(); }

    findDevice(options) {
      const configured = this.dataset.deviceOption.trim().toLowerCase();
      return options.find(option => configured ? option.name.toLowerCase() === configured : /device|model|iphone/i.test(option.name));
    }

    selectedDevice() {
      if (!this.deviceOption) return null;
      const name = this.deviceOption.name;
      const picker = this.productInfo.querySelector('variant-selects');
      const input = Array.from(picker?.querySelectorAll('input:checked, select') || []).find(element =>
        element.name === `${name}-${this.deviceOption.position}` || element.name === `options[${name}]`
      );
      return input?.value || null;
    }

    updateLink(link) {
      const options = JSON.parse(link.parentElement.querySelector('[data-design-options]').textContent);
      const targetDevice = this.findDevice(options);
      const selected = this.selectedDevice();
      const match = targetDevice?.values.find(value => value.name === selected);
      const url = new URL(link.getAttribute('href'), window.location.origin);
      url.searchParams.delete('variant');
      url.searchParams.delete('option_values');
      url.searchParams.delete('naked_choose_device');
      if (match) url.searchParams.set('option_values', match.id);
      else if (targetDevice) url.searchParams.set('naked_choose_device', '1');
      link.href = `${url.pathname}${url.search}${url.hash}`;
    }

    requireDevice() {
      this.requiresDevice = true;
      this.querySelector('[role="status"]').hidden = false;
      const picker = this.productInfo.querySelector('variant-selects');
      const option = this.deviceOption;
      picker?.querySelectorAll('input').forEach(input => {
        if (input.name === `${option.name}-${option.position}`) input.checked = false;
      });
      picker?.querySelectorAll('select').forEach(select => {
        if (select.name === `options[${option.name}]`) select.selectedIndex = -1;
      });
      this.productInfo.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(input => { input.value = ''; });
      this.productInfo.querySelector('product-form')?.toggleSubmitButton(true);
    }
  });
}
